/* TS Home Supply — clickable finish swatches on collection cards.
   Click a finish dot -> swap the card image to that finish's variant photo IF one exists;
   otherwise the current image stays. Selected finish gets a brass ring (see tsb-card-swatch.css).
   Hover -> a styled name tooltip (built here so we can drop the slow native title tooltip).
   FINISH_NAMES maps the stored option CODE -> shopper-friendly name for the tooltip/aria only;
   the code is kept on data-finish so the click-to-swap variant matching still works.
   LOCALIZED: zh-CN + es tooltip names via Shopify.locale (mirrors snippets/tsb-finish-name.liquid). */
(function () {
  if (window.__tsbCardSwatch) return;
  window.__tsbCardSwatch = 1;
  var LOC = (window.Shopify && Shopify.locale) || '';
  var ZH = LOC === 'zh-CN';
  var ES = LOC === 'es';
  var FINISH_NAMES_EN = {
    'cg&w': 'Charcoal Gray & White',
    'cfoa': 'CF Oak',
    'jnoa': 'JN Oak',
    'stoa': 'Star Oak'
  };
  var FINISH_NAMES_ZH = {
    'cg&w': '炭灰拼白',
    'cfoa': 'CF 橡木色',
    'jnoa': 'JN 深橡木色',
    'stoa': '星辰橡木色',
    'polished chrome': '抛光镀铬',
    'brushed nickel': '拉丝镍',
    'matte black': '哑光黑',
    'brushed gold': '拉丝金',
    'titanium gold': '铛金',
    'gunmetal gray': '炮铜灰',
    'light grey': '浅灰',
    'light gray': '浅灰',
    'white': '白色'
  };
  var FINISH_NAMES_ES = {
    'cg&w': 'Gris carbón y blanco',
    'cfoa': 'Roble CF',
    'jnoa': 'Roble JN',
    'stoa': 'Roble Star',
    'polished chrome': 'Cromo pulido',
    'brushed nickel': 'Níquel cepillado',
    'matte black': 'Negro mate',
    'brushed gold': 'Oro cepillado',
    'titanium gold': 'Oro titanio',
    'gunmetal gray': 'Gris grafito',
    'light grey': 'Gris claro',
    'light gray': 'Gris claro',
    'white': 'Blanco'
  };
  function pretty(code) {
    var k = code.toLowerCase();
    if (ZH && FINISH_NAMES_ZH[k]) return FINISH_NAMES_ZH[k];
    if (ES && FINISH_NAMES_ES[k]) return FINISH_NAMES_ES[k];
    return FINISH_NAMES_EN[k] || code;
  }
  var cache = {};
  function loadProduct(href) {
    if (!cache[href]) {
      cache[href] = fetch(href + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[href];
  }
  function paint() {
    document.querySelectorAll('.tsb-card-sw').forEach(function (s) {
      if (s.__tsbReady) return;
      s.__tsbReady = 1;
      var code = (s.getAttribute('title') || '').trim();
      if (code) {
        var name = pretty(code);
        s.setAttribute('data-finish', code);     /* code kept for variant matching */
        s.setAttribute('aria-label', name);
        s.removeAttribute('title');               /* drop the ~1s unstyled native tooltip */
        var tip = document.createElement('span');
        tip.className = 'tsb-sw-tip';
        tip.textContent = name;
        s.appendChild(tip);
      }
      if (!s.getAttribute('role')) { s.setAttribute('role', 'button'); s.tabIndex = 0; }
    });
  }
  function select(sw) {
    var group = sw.parentNode ? sw.parentNode.querySelectorAll('.tsb-card-sw') : [];
    for (var i = 0; i < group.length; i++) group[i].classList.remove('is-selected');
    sw.classList.add('is-selected');
  }
  function handle(sw) {
    var card = sw.closest('.card-wrapper');
    if (!card) return;
    select(sw);
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('.card__media img');
    var finish = (sw.getAttribute('data-finish') || sw.getAttribute('title') || '').trim().toLowerCase();
    if (!link || !img || !finish) return;
    var href = link.getAttribute('href').split('?')[0];
    loadProduct(href).then(function (p) {
      if (!p || !p.variants) return;
      var match = p.variants.find(function (v) {
        var opts = (v.options || []).map(function (o) { return (o || '').toLowerCase(); });
        return opts.indexOf(finish) !== -1 && v.featured_image && v.featured_image.src;
      });
      if (match) { img.setAttribute('srcset', ''); img.src = match.featured_image.src; }
    });
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.tsb-card-sw');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    handle(sw);
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('tsb-card-sw')) {
      e.preventDefault();
      handle(e.target);
    }
  });
  if (document.readyState !== 'loading') paint();
  else document.addEventListener('DOMContentLoaded', paint);
  document.addEventListener('shopify:section:load', paint);
})();
